/**
 * HOTFIX: TenantNotFound / TenantLoading page.
 *
 * Rendered when the SPA is loaded on a tenant subdomain that doesn't
 * resolve to any tenant in the registry (or DNS wildcard hits an
 * unknown/unlaunched tenant).
 *
 * Deliberately friendly + informative — never leaks that this is the
 * Owner Portal domain. Provides a link to app.dynicty.com for real
 * platform owners who mistyped.
 */
import React from "react";
import { Loader2, ServerCrash, ExternalLink } from "lucide-react";

export function TenantLoading({ host }) {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-purple-950 grid place-items-center px-6"
      data-testid="tenant-loading-page"
    >
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-cyan-400 animate-spin mx-auto" />
        <div className="text-white/70 text-sm mt-4 font-mono">Memuat {host || "tenant"}…</div>
      </div>
    </div>
  );
}

export default function TenantNotFound({ host, reason = "not-found" }) {
  const title = reason === "network"
    ? "Tidak dapat menghubungi server"
    : "Toko belum tersedia";
  const desc = reason === "network"
    ? "Ada masalah dengan koneksi. Coba refresh halaman ini beberapa saat lagi."
    : "Alamat ini belum terhubung dengan toko manapun, atau toko masih dalam persiapan.";
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-rose-950 grid place-items-center px-6"
      data-testid="tenant-not-found-page"
    >
      <div className="max-w-md text-center">
        <div className="w-20 h-20 mx-auto rounded-3xl bg-rose-500/15 border border-rose-500/40 grid place-items-center mb-6">
          <ServerCrash className="w-10 h-10 text-rose-300" />
        </div>
        <h1 className="text-white font-display font-black text-3xl mb-2">{title}</h1>
        <p className="text-white/70 text-sm mb-2">{desc}</p>
        {host && (
          <div className="inline-block px-3 py-1 rounded-full bg-white/5 border border-white/10 font-mono text-xs text-white/60 mb-6">
            {host}
          </div>
        )}
        <div className="text-white/50 text-xs mt-4">
          Kalau kamu owner toko dan baru saja melakukan launch, tunggu beberapa menit dan refresh.
        </div>
        <div className="text-white/40 text-[11px] mt-6">
          Platform Owner? <a
            href="https://app.dynicty.com/platform/login"
            className="text-cyan-300 hover:text-cyan-200 inline-flex items-center gap-1"
            data-testid="tenant-not-found-platform-link"
          >
            Buka Platform Console <ExternalLink size={11} />
          </a>
        </div>
      </div>
    </div>
  );
}
